import React from 'react';

interface HubSpotIconProps {
  className?: string;
}

const HubSpotIcon: React.FC<HubSpotIconProps> = ({ className = "h-6 w-6" }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* HubSpot Orange Brand Color */}
      <defs>
        <linearGradient id="hubspot-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FF7A59" />
          <stop offset="100%" stopColor="#FF5722" />
        </linearGradient>
      </defs>
      
      {/* Main HubSpot Logo Shape */}
      <g fill="url(#hubspot-gradient)">
        {/* Center Hub */}
        <circle cx="12" cy="12" r="2.5" />
        
        {/* Outer Ring with Spokes */}
        <g>
          {/* Top Spoke */}
          <rect x="11" y="2" width="2" height="5" rx="1" />
          <circle cx="12" cy="3.5" r="1.5" />
          
          {/* Top Right Spoke */}
          <rect x="16.5" y="4.8" width="2" height="5" rx="1" transform="rotate(45 17.5 7.3)" />
          <circle cx="18.5" cy="5.5" r="1.5" />
          
          {/* Right Spoke */}
          <rect x="17" y="11" width="5" height="2" rx="1" />
          <circle cx="20.5" cy="12" r="1.5" />
          
          {/* Bottom Right Spoke */}
          <rect x="16.5" y="14.2" width="2" height="5" rx="1" transform="rotate(-45 17.5 16.7)" />
          <circle cx="18.5" cy="18.5" r="1.5" />
          
          {/* Bottom Spoke */}
          <rect x="11" y="17" width="2" height="5" rx="1" />
          <circle cx="12" cy="20.5" r="1.5" />
          
          {/* Bottom Left Spoke */}
          <rect x="5.5" y="14.2" width="2" height="5" rx="1" transform="rotate(45 6.5 16.7)" />
          <circle cx="5.5" cy="18.5" r="1.5" />
          
          {/* Left Spoke */}
          <rect x="2" y="11" width="5" height="2" rx="1" />
          <circle cx="3.5" cy="12" r="1.5" />
          
          {/* Top Left Spoke */}
          <rect x="5.5" y="4.8" width="2" height="5" rx="1" transform="rotate(-45 6.5 7.3)" />
          <circle cx="5.5" cy="5.5" r="1.5" />
        </g>
      </g>
    </svg>
  );
};

export default HubSpotIcon;




